__turbopack_context__.v({
  "banner-image": "BannerPicture-module-scss-module__YeXjkW__banner-image",
  "banner-image-container": "BannerPicture-module-scss-module__YeXjkW__banner-image-container",
});
